module.exports = __webpack_public_path__ + "img/中国林业体育协会@3x.613d5dcf.png";